export default __webpack_public_path__ + "assets/893d23bf4adaa3aa3b0975bf5fe68eb3/11.jpg";